import { defineMessages } from 'react-intl';

export const patientDocumentMessages = defineMessages({
  empty: {
    id: 'patientDocuments.empty',
    defaultMessage:
      'No documents yet. Create a treatment plan or multimodal report.',
  },
  editDocument: {
    id: 'patientDocuments.editDocument',
    defaultMessage: 'Edit',
  },
  untitledDocument: {
    id: 'patientDocuments.untitledDocument',
    defaultMessage: 'Untitled document',
  },
  printPdf: {
    id: 'patientDocuments.printPdf',
    defaultMessage: 'Print / save PDF',
  },
  cancel: { id: 'global.cancel', defaultMessage: 'Cancel' },
  saveToPatient: {
    id: 'patientDocuments.saveToPatient',
    defaultMessage: 'Save',
  },
  document: { id: 'global.document', defaultMessage: 'Document' },
  agent: { id: 'patientDocuments.agent', defaultMessage: 'Agent' },
  loadingDocumentImages: {
    id: 'patientDocuments.loadingDocumentImages',
    defaultMessage: 'Loading document and images…',
  },
  uploadDocumentImage: {
    id: 'patientDocuments.uploadDocumentImage',
    defaultMessage: 'Upload document image',
  },
  chooseReportImage: {
    id: 'patientDocuments.chooseReportImage',
    defaultMessage: "Choose an image from this patient's reports",
  },
  insertImage: {
    id: 'patientDocuments.insertImage',
    defaultMessage: 'Insert image',
  },
  searchReportImages: {
    id: 'patientDocuments.searchReportImages',
    defaultMessage: 'Search report images',
  },
  searchImagesPlaceholder: {
    id: 'patientDocuments.searchImagesPlaceholder',
    defaultMessage: 'Search available report images…',
  },
  closeImagePicker: {
    id: 'patientDocuments.closeImagePicker',
    defaultMessage: 'Close image picker',
  },
  chooseStudy: {
    id: 'patientDocuments.chooseStudy',
    defaultMessage: 'Choose study',
  },
  studies: { id: 'patientDocuments.studies', defaultMessage: 'Studies' },
  studyNumber: {
    id: 'patientDocuments.studyNumber',
    defaultMessage: 'Study {number}',
  },
  imageCount: {
    id: 'patientDocuments.imageCount',
    defaultMessage: '{count, plural, one {# image} other {# images}}',
  },
  allAvailable: {
    id: 'patientDocuments.allAvailable',
    defaultMessage: 'All available',
  },
  allAvailableImages: {
    id: 'patientDocuments.allAvailableImages',
    defaultMessage: 'All available images',
  },
  filterReportImages: {
    id: 'patientDocuments.filterReportImages',
    defaultMessage: 'Filter report images',
  },
  filterByTooth: {
    id: 'patientDocuments.filterByTooth',
    defaultMessage: 'Filter by tooth',
  },
  orientation: {
    id: 'patientDocuments.orientation',
    defaultMessage: 'Orientation',
  },
  filterByOrientation: {
    id: 'patientDocuments.filterByOrientation',
    defaultMessage: 'Filter by orientation',
  },
  allOrientations: {
    id: 'patientDocuments.allOrientations',
    defaultMessage: 'All orientations',
  },
  availableImages: {
    id: 'patientDocuments.availableImages',
    defaultMessage: 'Available images',
  },
  selectTooth: {
    id: 'patientDocuments.selectTooth',
    defaultMessage: 'Select a tooth to view its slices',
  },
  imagesFromReports: {
    id: 'patientDocuments.imagesFromReports',
    defaultMessage: 'Images from reports',
  },
  imageUnavailable: {
    id: 'patientDocuments.imageUnavailable',
    defaultMessage: 'Image unavailable',
  },
  loadMoreImages: {
    id: 'patientDocuments.loadMoreImages',
    defaultMessage: 'Load more images',
  },
  loadingImaging: {
    id: 'patientDocuments.loadingImaging',
    defaultMessage: 'Loading patient imaging…',
  },
  noCompatibleImages: {
    id: 'patientDocuments.noCompatibleImages',
    defaultMessage:
      'No compatible report images are available for this patient.',
  },
  imagePickerHint: {
    id: 'patientDocuments.imagePickerHint',
    defaultMessage: 'Click an image to preview and insert it.',
  },
  imagePreview: {
    id: 'patientDocuments.imagePreview',
    defaultMessage: 'Image preview',
  },
  closePreview: {
    id: 'patientDocuments.closePreview',
    defaultMessage: 'Close preview',
  },
  renderingSlice: {
    id: 'patientDocuments.renderingSlice',
    defaultMessage: 'Rendering slice…',
  },
  discardChanges: {
    id: 'patientDocuments.discardChanges',
    defaultMessage: 'Discard unsaved document changes?',
  },
  selectedUnavailable: {
    id: 'patientDocuments.selectedUnavailable',
    defaultMessage: 'The selected document is no longer available.',
  },
  titleRequired: {
    id: 'patientDocuments.titleRequired',
    defaultMessage: 'Document title is required.',
  },
  saveFailed: {
    id: 'patientDocuments.saveFailed',
    defaultMessage: 'The document could not be saved.',
  },
  createdDocumentUnavailable: {
    id: 'patientDocuments.createdDocumentUnavailable',
    defaultMessage: 'The created document could not be loaded.',
  },
  createFailed: {
    id: 'patientDocuments.createFailed',
    defaultMessage: 'The document could not be created.',
  },
  uploadStartFailed: {
    id: 'patientDocuments.uploadStartFailed',
    defaultMessage: 'The upload could not be started.',
  },
  uploadFailed: {
    id: 'patientDocuments.uploadFailed',
    defaultMessage: 'The image could not be uploaded.',
  },
  uploadRegistrationPending: {
    id: 'patientDocuments.uploadRegistrationPending',
    defaultMessage:
      'The uploaded image has not been registered yet. Please try again.',
  },
  uploadedImage: {
    id: 'patientDocuments.uploadedImage',
    defaultMessage: 'Uploaded image',
  },
  imageInsertFailed: {
    id: 'patientDocuments.imageInsertFailed',
    defaultMessage: 'The image could not be inserted.',
  },
  selectTextRewrite: {
    id: 'patientDocuments.selectTextRewrite',
    defaultMessage: 'Select document text before applying a rewrite.',
  },
  selectTextInsert: {
    id: 'patientDocuments.selectTextInsert',
    defaultMessage: 'Select document text before inserting content.',
  },
  treatmentPlan: {
    id: 'patientDocuments.treatmentPlan',
    defaultMessage: 'Treatment plan',
  },
  pathologySlices: {
    id: 'patientDocuments.pathologySlices',
    defaultMessage: 'Pathology slices',
  },
  toothSlices: {
    id: 'patientDocuments.toothSlices',
    defaultMessage: 'Tooth slices',
  },
  mprVolumes: {
    id: 'patientDocuments.mprVolumes',
    defaultMessage: 'MPR volumes',
  },
  mprPlanes: { id: 'patientDocuments.mprPlanes', defaultMessage: 'MPR planes' },
  uploadedToothSlices: {
    id: 'patientDocuments.uploadedToothSlices',
    defaultMessage: 'Uploaded tooth slices',
  },
  panoramicSplitViews: {
    id: 'patientDocuments.panoramicSplitViews',
    defaultMessage: 'Panoramic split views',
  },
  panoramicReconstructions: {
    id: 'patientDocuments.panoramicReconstructions',
    defaultMessage: 'Panoramic reconstructions',
  },
  periodontium: {
    id: 'patientDocuments.periodontium',
    defaultMessage: 'Periodontium',
  },
  endodonticViews: {
    id: 'patientDocuments.endodonticViews',
    defaultMessage: 'Endodontic views',
  },
  endodonticCrossSections: {
    id: 'patientDocuments.endodonticCrossSections',
    defaultMessage: 'Endodontic cross-sections',
  },
  implantViews: {
    id: 'patientDocuments.implantViews',
    defaultMessage: 'Implant views',
  },
  implantSlices: {
    id: 'patientDocuments.implantSlices',
    defaultMessage: 'Implant slices',
  },
  molarViews: {
    id: 'patientDocuments.molarViews',
    defaultMessage: 'Molar views',
  },
  molarCrossSections: {
    id: 'patientDocuments.molarCrossSections',
    defaultMessage: 'Molar cross-sections',
  },
  intraoralXrays: {
    id: 'patientDocuments.intraoralXrays',
    defaultMessage: 'Intraoral X-rays',
  },
  reportFigures: {
    id: 'patientDocuments.reportFigures',
    defaultMessage: 'Report figures',
  },
  reportImages: {
    id: 'patientDocuments.reportImages',
    defaultMessage: 'Report images',
  },
  axial: { id: 'patientDocuments.axial', defaultMessage: 'Axial' },
  coronal: { id: 'patientDocuments.coronal', defaultMessage: 'Coronal' },
  sagittal: { id: 'patientDocuments.sagittal', defaultMessage: 'Sagittal' },
  caption: { id: 'patientDocuments.caption', defaultMessage: 'Caption' },
  documentTitle: {
    id: 'patientDocuments.documentTitle',
    defaultMessage: 'Document title',
  },
  documentFormatting: {
    id: 'patientDocuments.documentFormatting',
    defaultMessage: 'Document formatting',
  },
  undo: { id: 'patientDocuments.undo', defaultMessage: 'Undo' },
  redo: { id: 'patientDocuments.redo', defaultMessage: 'Redo' },
  text: { id: 'patientDocuments.text', defaultMessage: 'Text' },
  mainHeading: {
    id: 'patientDocuments.mainHeading',
    defaultMessage: 'Main heading',
  },
  heading: { id: 'patientDocuments.heading', defaultMessage: 'Heading' },
  subheading: {
    id: 'patientDocuments.subheading',
    defaultMessage: 'Subheading',
  },
  bold: { id: 'patientDocuments.bold', defaultMessage: 'Bold' },
  italic: { id: 'patientDocuments.italic', defaultMessage: 'Italic' },
  bullets: { id: 'patientDocuments.bullets', defaultMessage: 'Bullets' },
  numbered: { id: 'patientDocuments.numbered', defaultMessage: 'Numbered' },
  uploadImage: {
    id: 'patientDocuments.uploadImage',
    defaultMessage: 'Upload image',
  },
  insertReportImage: {
    id: 'patientDocuments.insertReportImage',
    defaultMessage: 'Insert report image',
  },
  documentContent: {
    id: 'patientDocuments.documentContent',
    defaultMessage: 'Document content',
  },
  startWriting: {
    id: 'patientDocuments.startWriting',
    defaultMessage: 'Start writing…',
  },
  toothNumber: {
    id: 'patientDocuments.toothNumber',
    defaultMessage: 'tooth {number}',
  },
  sliceNumber: {
    id: 'patientDocuments.sliceNumber',
    defaultMessage: 'slice {number}',
  },
  sliceNumberOf: {
    id: 'patientDocuments.sliceNumberOf',
    defaultMessage: 'slice {number} of {total}',
  },
  editImage: {
    id: 'patientDocuments.editImage',
    defaultMessage: 'Edit image: {caption}',
  },
  untitled: { id: 'patientDocuments.untitled', defaultMessage: 'untitled' },
  image: { id: 'patientDocuments.image', defaultMessage: 'image' },
  remove: { id: 'global.remove', defaultMessage: 'Remove' },
  rotate: { id: 'patientDocuments.rotate', defaultMessage: 'Rotate' },
  flip: { id: 'patientDocuments.flip', defaultMessage: 'Flip' },
  invert: { id: 'patientDocuments.invert', defaultMessage: 'Invert' },
  dim: { id: 'patientDocuments.dim', defaultMessage: 'Dim' },
  brighten: { id: 'patientDocuments.brighten', defaultMessage: 'Brighten' },
  lessContrast: {
    id: 'patientDocuments.lessContrast',
    defaultMessage: 'Less contrast',
  },
  moreContrast: {
    id: 'patientDocuments.moreContrast',
    defaultMessage: 'More contrast',
  },
  zoomIn: { id: 'patientDocuments.zoomIn', defaultMessage: 'Zoom in' },
  resetView: { id: 'patientDocuments.resetView', defaultMessage: 'Reset view' },
  save: { id: 'global.save', defaultMessage: 'Save' },
  moveLeft: { id: 'patientDocuments.moveLeft', defaultMessage: 'Move left' },
  moveRight: { id: 'patientDocuments.moveRight', defaultMessage: 'Move right' },
});
